

  <form [formGroup]="editMechanicForm" >
    <div class="scrollbar app">
      <div class="row">
        <div class="col-3 af-form-group">
          <label translate>lblSelectDealer</label>
          <div class='lbl-info'>
            <app-dealer-searchbox-dropdown [dealerList]="dealerList"  ngDefaultControl [selectedDealer]="dealerId" formControlName="dealerName" (onSelectDealer)="onDealerSelected($event)" [clear]="false" placeholder="Search Dealer">
            </app-dealer-searchbox-dropdown>

            <div *ngIf="cpf.dealerName.invalid && (cpf.dealerName.dirty || cpf.dealerName.touched)" class="help-block text-danger">
              <div *ngIf="cpf.dealerName.errors.required"><span translate>lblDealerRequired</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Mechanic Name -->
        <div class="col-3 af-form-group">
          <label for="mechanic" translate>lblName <span class="required">*</span></label>
          <div class="lbl-info">
            <input formControlName="name" class="form-control mb-2" required>
            <div *ngIf="cpf.name.touched && (cpf.name.errors?.required)" class="help-block mt-1 text-danger" translate>
              lblNameRequired</div>
          </div>
        </div>

        <!-- employeeNo -->
        <div class="col-3 af-form-group">
          <label for="mechanic" translate>lblEmployeeNumber <span class="required">*</span></label>
          <div class="lbl-info">
            <input formControlName="employeeNo" class="form-control mb-2" required>
            <div *ngIf="cpf.employeeNo.touched && (cpf.employeeNo.errors?.required)" class="help-block mt-1 text-danger"
              translate>lblEmployeeNumberRequired</div>
          </div>
        </div>

        <!-- dmsMechanicNo -->
        <div class="col-3 af-form-group" *ngIf="isDmsMechanicIdUsed">
          <label for="mechanic" translate>lblDmsMechanicId <span class="required">*</span></label>
          <div class="lbl-info">
            <input formControlName="dmsMechanicNo" class="form-control mb-2" required>
            <div *ngIf="cpf.dmsMechanicNo.touched && (cpf.dmsMechanicNo.errors?.required)" class="help-block mt-1 text-danger"
              translate>lblDmsMechanicIdRequired</div>
          </div>
        </div>

        <!-- adUserId -->
        <div class="col-3 af-form-group">
          <label for="mechanic" translate>lblADGUID</label>
          <div class="lbl-info">
            <input type="text" id="template-edit-adUserId " name="adUserId" formControlName="adUserId" class="form-control" required
              maxlength="50" placeholder="{{ 'lblEnterADGUID' | translate }}"
              [ngClass]="{'is-invalid': cpf.adUserId .invalid && cpf.adUserId .touched}">
            <div *ngIf="cpf.adUserId .invalid && (cpf.adUserId .dirty || cpf.adUserId .touched)" class="help-block text-danger">
              <div *ngIf="cpf.adUserId .errors.required"><span translate>lblADGUIDRequire</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ADEmail -->
        <div class="col-3 af-form-group">
          <label for="ADUSerId"><span translate>lblADEmail</span> <span class="text-danger"> * </span>
          </label>
          <div class="lbl-info">
              <input formControlName="adEmail" id="adEmail" class="form-control mb-2"
                  [ngClass]="{'is-invalid': (cpf.adEmail.touched || cpf.adEmail.dirty) && cpf.adEmail.errors}"
                  placeholder="{{ 'lblEnterADEmail' | translate }}" maxlength="50">
              <div *ngIf="(cpf.adEmail.touched || cpf.adEmail.dirty) && cpf.adEmail.errors">
                  <div *ngIf="cpf.adEmail.errors.required" class="help-block mt-1 text-danger" translate>
                      lblADEmailRequired
                  </div>
                  <div *ngIf="cpf.adEmail.errors.pattern" class="help-block mt-1 text-danger" translate>
                      lblEnterValidADEmail
                  </div>
              </div>
          </div>
      </div>

        <!-- Is Active -->
        <div class="col-3 af-form-group">
          <label>&nbsp;</label>
          <div class="lbl-info">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive"
                (change)="onChangeIsActive(mechanicInfo.isActive)">
              <label class="custom-control-label" for="isActive" translate>lblActive</label>
            </div>
          </div>
        </div>

        <!-- capacityPlanning -->
        <div class="col-3 af-form-group">
          <label>&nbsp;</label>
          <div class="lbl-info">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="isCapacityPlanning" formControlName="isCapacityPlanning"
                (change)="onChangecapacityPlanning(mechanicInfo.isCapacityPlanning)">
              <label class="custom-control-label" for="isCapacityPlanning" translate>lblCapacityPlanning</label>
            </div>
          </div>
        </div>
        <!-- Consider Customer Waiting Slots -->
        <div class="col-3 af-form-group" *ngIf="isCustomerWaitingSlotsEnabled">
          <label>&nbsp;</label>
          <div class="lbl-info">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="isConsiderCustomerWaitingSlots" formControlName="isConsiderCustomerWaitingSlots"
                (change)="onChangeConsiderCustomerWaitingSlots(mechanicInfo.isConsiderCustomerWaitingSlots)">
              <label class="custom-control-label" for="isConsiderCustomerWaitingSlots" translate>lblConsiderCustomerWaitingSlots</label>
            </div>
          </div>
        </div>
        <div class="col-3 af-form-group" *ngIf="!isDmsMechanicIdUsed && !isCustomerWaitingSlotsEnabled">
        </div>
        <!-- NotAvailable -->
        <div class="col-3 af-form-group">
          <label>&nbsp;</label>
          <div class="lbl-info">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="isNotAvailable" formControlName="isNotAvailable"
                (change)="onChangeIsNotAvailable(mechanicInfo.isNotAvailable)">
              <label class="custom-control-label" for="isNotAvailable" translate>lblNotAvailable</label>
            </div>
          </div>
        </div>

        <!-- NotAvailable Enddate -->

        <div class="col-3 af-form-group" *ngIf="mechanicInfo?.isNotAvailable">
          <label for="template-edit-startDate" translate>lblNotAvailableEndDate<span>:</span>
          </label>
          <div class="lbl-info date">
            <input class="form-control datePicker width100force" appAfDatepicker [ngModelOptions]="{standalone: true}"
              [dateTime]="true"  [ngModel]="mechanicInfo.notAvailableEndDate" [disableNextMonthDates]="true"
              (ngModelChange)="onChangeNotAvailableEndDate($event)" [defaultTime]="'00:00'"
              [isOnlyTime]="false"
              >
            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
          </div>
        </div>

      </div>
      <hr>
      <div class=" scrollbar user">
        <div class=" mb-3" >
          <div class="table-responsive mb-4 tableMx-15" >
            <div class="col-md-12 af-form-group">
              <div class="lbl-info">
                <span class="title16" translate>lblDealerMechanicAssociationHistory</span>
              </div>
            </div>
            <table class="tablest1">
              <thead>
                <tr>
                  <th style="width: 10%" scope="col">#</th>
                  <th style="width: 20%" scope="col"><span translate>lblDealerName</span></th>
                  <th style="width: 20%" scope="col" translate>lblStartDate</th>
                  <th style="width: 20%" scope="col" translate>lblEndDate</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="dealerMechanicAssociationHistory?.length>0; else load_else">
                  <tr *ngFor="let item of dealerMechanicAssociationHistory; let i=index">
                    <td>
                     {{i+1}}
                    </td>
                    <td>
                      {{item.dealerName }}
                    </td>
                    <td>
                      {{item.startDate | date:'short'}}
                    </td>
                    <td>
                      {{item.endDate | date:'short'}}
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_else>
                  <tr>
                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
      <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
        <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="!editMechanicForm.valid"
        (click)="EditMechanicBasicDetail(false)" translate>lblSaveChanges</button>
        <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="!editMechanicForm.valid"
        (click)="EditMechanicBasicDetail(true)" translate>lblSaveAndClose</button>
        <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblBack</a>
      </div>
    </div>
  </div>
  </form>
